module.exports = __webpack_public_path__ + "static/media/Grey-checkmark-ready-to-process.910d5a1d.png";